"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findLastIndex = findLastIndex;
exports.getElementDocument = getElementDocument;
exports.getElementWindow = getElementWindow;
exports.isDOMElement = isDOMElement;
exports.isFunction = isFunction;
exports.mergeRefs = void 0;
exports.repeat = repeat;
exports.toString = toString;
// Element's window may differ from the one within React instance
// if element rendered within iframe.
// See https://github.com/sanniassin/react-input-mask/issues/182
function getElementDocument(element) {
  return (element === null || element === void 0 ? void 0 : element.ownerDocument) || undefined;
}
function getElementWindow(element) {
  const document = getElementDocument(element);
  return (document === null || document === void 0 ? void 0 : document.defaultView) || undefined;
}
function isDOMElement(element) {
  if (!element) {
    return false;
  }
  const elementWindow = getElementWindow(element);
  // @ts-ignore
  return !!elementWindow && element instanceof elementWindow.HTMLElement;
}
function isFunction(value) {
  return typeof value === 'function';
}
function findLastIndex(array, predicate) {
  for (let i = array.length - 1; i >= 0; i--) {
    const x = array[i];
    if (predicate(x, i)) {
      return i;
    }
  }
  return -1;
}
function repeat(string) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  let result = '';
  for (let i = 0; i < n; i++) {
    result += string;
  }
  return result;
}
function toString(value) {
  return "".concat(value);
}
const mergeRefs = function () {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
};
exports.mergeRefs = mergeRefs;